import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledActions = styled.div`
    margin: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const Actions = (props) => {
    const {
        children,
    } = props;

    return (
        <StyledActions>
            { children }
        </StyledActions>
    );
};

Actions.propTypes = {
    children: PropTypes.node,
};

export default Actions;



// WEBPACK FOOTER //
// ./src/components/ui/general/Actions.js